import { GameResult } from 'modules/games/ui/components/game-result';
import MomentsPage from 'modules/games/ui/components/moments/moments-page';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { ChampionshipStageTab } from 'modules/championship/domain/enums/championship-stage-tab';
import { StageMatchTab } from 'modules/championship/domain/enums/stage-match-tab';
import { StageV2 } from 'modules/championship/domain/interfaces/stage';
import { Pages } from 'modules/navigation/domain/enums/pages';

interface StageMatchRoutesProps {
  championshipId: number;
  stage: StageV2;
}

/**
 * Страница матча: `/steps/:stageId/matches/:gameId/result|moments`.
 *
 * `GameResult` и `MomentsPage` тянут детали матча сами, поэтому прямой заход по
 * адресу работает без списка матчей. Здесь достаточно убедиться, что матч
 * принадлежит этому этапу, — иначе таб-бар не смог бы подписать вкладку.
 */
const StageMatchRoutes = ({ championshipId, stage }: StageMatchRoutesProps) => {
  const { gameId: rawGameId } = useParams();

  const gameId = Number(rawGameId);
  const game = Number.isInteger(gameId) ? stage.matches.find((match) => match.id === gameId) : undefined;

  if (!game) {
    return (
      <Navigate
        to={Pages.CHAMPIONSHIPS.STEPS.builders.stage(championshipId, stage.id, ChampionshipStageTab.MATCHES)}
        replace
      />
    );
  }

  return (
    <Routes>
      <Route path={StageMatchTab.RESULT} element={<GameResult gameId={game.id} championshipId={championshipId} />} />
      <Route path={StageMatchTab.MOMENTS} element={<MomentsPage gameId={game.id} championshipId={championshipId} />} />
      {/* Голый `/matches/:gameId` — на результат: это дефолт билдера. */}
      <Route
        path="*"
        element={<Navigate to={Pages.CHAMPIONSHIPS.STEPS.builders.match(championshipId, stage.id, game.id)} replace />}
      />
    </Routes>
  );
};

export default StageMatchRoutes;
